export class AuthenticationRequestModel {
  Username: string = '';
  Email: string = '';
  Password: string = '';
  LocationId: string = '';
  WorkstationName: string = '';
  LoginType: string = '';
}
